// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mural-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px;
}

.mural-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.mural-search {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 280px;
  background: #ffffff;
  border: 1px solid #d7e3f3;
  border-radius: 12px;
  padding: 0 12px;
  min-height: 46px;
  color: #1c2c44;
}

.mural-search input {
  border: none;
  width: 100%;
  outline: none;
  background: transparent;
  color: #1c2c44;
  font-size: 0.95rem;
}

.mural-search input::placeholder {
  color: #7a8fae;
}

html[data-theme="dark"] .mural-search {
  background: #0c1831;
  border-color: #1f3f69;
  color: #d6e6ff;
}

html[data-theme="dark"] .mural-search input {
  color: #d6e6ff;
}

html[data-theme="dark"] .mural-search input::placeholder {
  color: #87a6d4;
}

.mural-manage-button {
  border: none;
  background: #0f4c81;
  color: #fff;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.mural-notices-only {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mural-notice-card,
.mural-empty-state {
  background: #fff;
  border: 1px solid #e0ebf8;
  border-radius: 12px;
}

html[data-theme="dark"] .mural-notice-card,
html[data-theme="dark"] .mural-empty-state {
  background: #0f1b33;
  border-color: #29476f;
}

.mural-notice-card {
  padding: 14px;
}

.mural-notice-card.priority-alta {
  border-left: 4px solid #d7263d;
}

.mural-notice-card.priority-media {
  border-left: 4px solid #f2994a;
}

.mural-notice-card.priority-baixa {
  border-left: 4px solid #1ea672;
}

.mural-notice-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 10px;
}

.mural-notice-header h3 {
  margin: 0;
  color: #173a5f;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

html[data-theme="dark"] .mural-notice-header h3 {
  color: #dbeafe;
}

.notice-type-badge {
  font-size: 0.72rem;
  background: #e8f0fc;
  color: #204870;
  border-radius: 999px;
  padding: 4px 8px;
  text-transform: uppercase;
  font-weight: 700;
}

html[data-theme="dark"] .notice-type-badge {
  background: #1d3557;
  color: #dbeafe;
}

.priority-badge {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #425b77;
  background: #edf3fb;
  border-radius: 999px;
  padding: 4px 8px;
}

html[data-theme="dark"] .priority-badge {
  color: #bfdbfe;
  background: #21334f;
}

.mural-notice-card p {
  margin: 10px 0;
  color: #2e4867;
  line-height: 1.4;
}

html[data-theme="dark"] .mural-notice-card p {
  color: #cbd5e1;
}

.mural-event-date {
  margin: 8px 0;
  color: #2f5e8d;
  font-size: 0.88rem;
  font-weight: 600;
}

html[data-theme="dark"] .mural-event-date {
  color: #93c5fd;
}

.mural-cover-wrapper {
  margin: 10px 0;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #d8e5f4;
}

html[data-theme="dark"] .mural-cover-wrapper {
  border-color: #355780;
}

.mural-cover {
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  display: block;
}

.mural-message-content {
  color: #2e4867;
  line-height: 1.45;
}

html[data-theme="dark"] .mural-message-content {
  color: #cbd5e1;
}

html[data-theme="dark"] .mural-message-content :is(p, span, strong, em, li, a) {
  color: inherit;
}

.mural-message-content p {
  margin: 10px 0;
}

.mural-notice-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 0.83rem;
  color: #4f6482;
}

html[data-theme="dark"] .mural-notice-footer {
  color: #9fb5d2;
}

.audience-chip {
  background: #eef4fb;
  border-radius: 999px;
  padding: 3px 10px;
  font-weight: 600;
}

html[data-theme="dark"] .audience-chip {
  background: #223551;
  color: #c4d8f6;
}

.edited-at {
  color: #1f5d9c;
  font-weight: 600;
}

html[data-theme="dark"] .edited-at {
  color: #93c5fd;
}

.mural-notice-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.mural-notice-actions button {
  border: 1px solid #c2d6ec;
  border-radius: 8px;
  background: #fff;
  color: #2b4e76;
  padding: 6px 10px;
  font-size: 0.82rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

html[data-theme="dark"] .mural-notice-actions button {
  border-color: #3a5f8b;
  background: #11223d;
  color: #cfe1fb;
}

.mural-notice-actions button.danger {
  border-color: #f3c8c8;
  color: #8f1e1e;
  background: #fff5f5;
}

html[data-theme="dark"] .mural-notice-actions button.danger {
  border-color: #7f1d1d;
  color: #fecaca;
  background: #3b1212;
}

.mural-attachments {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mural-attachment-link {
  border: 1px solid #d6e4f5;
  border-radius: 999px;
  padding: 6px 10px;
  color: #234b73;
  font-size: 0.82rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

html[data-theme="dark"] .mural-attachment-link {
  border-color: #3a5f8b;
  color: #bfdbfe;
  background: #11223d;
}

.mural-empty-state {
  padding: 28px;
  color: #486282;
  display: grid;
  place-items: center;
  gap: 8px;
}

html[data-theme="dark"] .mural-empty-state {
  color: #b8cbe5;
}

.mural-modal-content h2 {
  margin: 0;
  color: #214f7d;
}

.mural-compose-form {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mural-compose-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #3b5778;
  font-size: 0.88rem;
}

.mural-compose-form input,
.mural-compose-form select,
.mural-compose-form textarea {
  border: 1px solid #cfe0f2;
  border-radius: 10px;
  padding: 9px 10px;
  font-size: 0.92rem;
}

.mural-compose-form textarea {
  resize: vertical;
}

.mural-editor-toolbar {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.mural-editor-toolbar button {
  border: 1px solid #cfe0f2;
  background: #fff;
  border-radius: 8px;
  min-width: 34px;
  padding: 0 10px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #29507a;
  cursor: pointer;
  font-weight: 700;
}

.mural-color-picker {
  border: 1px solid #cfe0f2;
  background: #fff;
  border-radius: 8px;
  height: 34px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #29507a;
}

.mural-color-picker input[type="color"] {
  border: none;
  padding: 0;
  background: transparent;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.mural-rich-editor {
  border: 1px solid #cfe0f2;
  border-radius: 10px;
  min-height: 140px;
  padding: 10px;
  background: #fff;
}

.mural-rich-editor:empty::before {
  content: attr(data-placeholder);
  color: #8ea0b6;
}

.mural-multi-select {
  min-height: 120px;
}

.mural-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.mural-form-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.mural-form-actions button {
  border: none;
  background: #0f4c81;
  color: #fff;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  cursor: pointer;
}

.mural-form-actions button.secondary {
  border: 1px solid #b7cade;
  color: #35577d;
  background: #fff;
}

.mural-upload-preview {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mural-upload-preview img {
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #d6e4f5;
}

.mural-attachment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mural-attachment-item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  border: 1px solid #d8e5f4;
  border-radius: 8px;
  padding: 8px 10px;
}

.mural-attachment-item span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #284e77;
  font-size: 0.86rem;
}

.mural-spacer {
  min-height: 1px;
}

@media (max-width: 620px) {
  .mural-page {
    padding: 0;
  }

  .mural-search {
    min-width: 100%;
  }

  .mural-form-row {
    grid-template-columns: 1fr;
  }

  .mural-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .mural-manage-button {
    width: 100%;
    justify-content: center;
  }

  .mural-notice-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .mural-notice-actions button {
    flex: 1 1;
    justify-content: center;
  }

  .mural-attachment-item {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Mural.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".mural-page {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px;\n}\n\n.mural-toolbar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.mural-search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 280px;\n  background: #ffffff;\n  border: 1px solid #d7e3f3;\n  border-radius: 12px;\n  padding: 0 12px;\n  min-height: 46px;\n  color: #1c2c44;\n}\n\n.mural-search input {\n  border: none;\n  width: 100%;\n  outline: none;\n  background: transparent;\n  color: #1c2c44;\n  font-size: 0.95rem;\n}\n\n.mural-search input::placeholder {\n  color: #7a8fae;\n}\n\nhtml[data-theme=\"dark\"] .mural-search {\n  background: #0c1831;\n  border-color: #1f3f69;\n  color: #d6e6ff;\n}\n\nhtml[data-theme=\"dark\"] .mural-search input {\n  color: #d6e6ff;\n}\n\nhtml[data-theme=\"dark\"] .mural-search input::placeholder {\n  color: #87a6d4;\n}\n\n.mural-manage-button {\n  border: none;\n  background: #0f4c81;\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.mural-notices-only {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mural-notice-card,\n.mural-empty-state {\n  background: #fff;\n  border: 1px solid #e0ebf8;\n  border-radius: 12px;\n}\n\nhtml[data-theme=\"dark\"] .mural-notice-card,\nhtml[data-theme=\"dark\"] .mural-empty-state {\n  background: #0f1b33;\n  border-color: #29476f;\n}\n\n.mural-notice-card {\n  padding: 14px;\n}\n\n.mural-notice-card.priority-alta {\n  border-left: 4px solid #d7263d;\n}\n\n.mural-notice-card.priority-media {\n  border-left: 4px solid #f2994a;\n}\n\n.mural-notice-card.priority-baixa {\n  border-left: 4px solid #1ea672;\n}\n\n.mural-notice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  gap: 10px;\n}\n\n.mural-notice-header h3 {\n  margin: 0;\n  color: #173a5f;\n  font-size: 1.05rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\nhtml[data-theme=\"dark\"] .mural-notice-header h3 {\n  color: #dbeafe;\n}\n\n.notice-type-badge {\n  font-size: 0.72rem;\n  background: #e8f0fc;\n  color: #204870;\n  border-radius: 999px;\n  padding: 4px 8px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\nhtml[data-theme=\"dark\"] .notice-type-badge {\n  background: #1d3557;\n  color: #dbeafe;\n}\n\n.priority-badge {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #425b77;\n  background: #edf3fb;\n  border-radius: 999px;\n  padding: 4px 8px;\n}\n\nhtml[data-theme=\"dark\"] .priority-badge {\n  color: #bfdbfe;\n  background: #21334f;\n}\n\n.mural-notice-card p {\n  margin: 10px 0;\n  color: #2e4867;\n  line-height: 1.4;\n}\n\nhtml[data-theme=\"dark\"] .mural-notice-card p {\n  color: #cbd5e1;\n}\n\n.mural-event-date {\n  margin: 8px 0;\n  color: #2f5e8d;\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\nhtml[data-theme=\"dark\"] .mural-event-date {\n  color: #93c5fd;\n}\n\n.mural-cover-wrapper {\n  margin: 10px 0;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #d8e5f4;\n}\n\nhtml[data-theme=\"dark\"] .mural-cover-wrapper {\n  border-color: #355780;\n}\n\n.mural-cover {\n  width: 100%;\n  max-height: 260px;\n  object-fit: cover;\n  display: block;\n}\n\n.mural-message-content {\n  color: #2e4867;\n  line-height: 1.45;\n}\n\nhtml[data-theme=\"dark\"] .mural-message-content {\n  color: #cbd5e1;\n}\n\nhtml[data-theme=\"dark\"] .mural-message-content :is(p, span, strong, em, li, a) {\n  color: inherit;\n}\n\n.mural-message-content p {\n  margin: 10px 0;\n}\n\n.mural-notice-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: 0.83rem;\n  color: #4f6482;\n}\n\nhtml[data-theme=\"dark\"] .mural-notice-footer {\n  color: #9fb5d2;\n}\n\n.audience-chip {\n  background: #eef4fb;\n  border-radius: 999px;\n  padding: 3px 10px;\n  font-weight: 600;\n}\n\nhtml[data-theme=\"dark\"] .audience-chip {\n  background: #223551;\n  color: #c4d8f6;\n}\n\n.edited-at {\n  color: #1f5d9c;\n  font-weight: 600;\n}\n\nhtml[data-theme=\"dark\"] .edited-at {\n  color: #93c5fd;\n}\n\n.mural-notice-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.mural-notice-actions button {\n  border: 1px solid #c2d6ec;\n  border-radius: 8px;\n  background: #fff;\n  color: #2b4e76;\n  padding: 6px 10px;\n  font-size: 0.82rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\nhtml[data-theme=\"dark\"] .mural-notice-actions button {\n  border-color: #3a5f8b;\n  background: #11223d;\n  color: #cfe1fb;\n}\n\n.mural-notice-actions button.danger {\n  border-color: #f3c8c8;\n  color: #8f1e1e;\n  background: #fff5f5;\n}\n\nhtml[data-theme=\"dark\"] .mural-notice-actions button.danger {\n  border-color: #7f1d1d;\n  color: #fecaca;\n  background: #3b1212;\n}\n\n.mural-attachments {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.mural-attachment-link {\n  border: 1px solid #d6e4f5;\n  border-radius: 999px;\n  padding: 6px 10px;\n  color: #234b73;\n  font-size: 0.82rem;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\nhtml[data-theme=\"dark\"] .mural-attachment-link {\n  border-color: #3a5f8b;\n  color: #bfdbfe;\n  background: #11223d;\n}\n\n.mural-empty-state {\n  padding: 28px;\n  color: #486282;\n  display: grid;\n  place-items: center;\n  gap: 8px;\n}\n\nhtml[data-theme=\"dark\"] .mural-empty-state {\n  color: #b8cbe5;\n}\n\n.mural-modal-content h2 {\n  margin: 0;\n  color: #214f7d;\n}\n\n.mural-compose-form {\n  margin-top: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mural-compose-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #3b5778;\n  font-size: 0.88rem;\n}\n\n.mural-compose-form input,\n.mural-compose-form select,\n.mural-compose-form textarea {\n  border: 1px solid #cfe0f2;\n  border-radius: 10px;\n  padding: 9px 10px;\n  font-size: 0.92rem;\n}\n\n.mural-compose-form textarea {\n  resize: vertical;\n}\n\n.mural-editor-toolbar {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.mural-editor-toolbar button {\n  border: 1px solid #cfe0f2;\n  background: #fff;\n  border-radius: 8px;\n  min-width: 34px;\n  padding: 0 10px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #29507a;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.mural-color-picker {\n  border: 1px solid #cfe0f2;\n  background: #fff;\n  border-radius: 8px;\n  height: 34px;\n  padding: 0 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #29507a;\n}\n\n.mural-color-picker input[type=\"color\"] {\n  border: none;\n  padding: 0;\n  background: transparent;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n}\n\n.mural-rich-editor {\n  border: 1px solid #cfe0f2;\n  border-radius: 10px;\n  min-height: 140px;\n  padding: 10px;\n  background: #fff;\n}\n\n.mural-rich-editor:empty::before {\n  content: attr(data-placeholder);\n  color: #8ea0b6;\n}\n\n.mural-multi-select {\n  min-height: 120px;\n}\n\n.mural-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.mural-form-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.mural-form-actions button {\n  border: none;\n  background: #0f4c81;\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.mural-form-actions button.secondary {\n  border: 1px solid #b7cade;\n  color: #35577d;\n  background: #fff;\n}\n\n.mural-upload-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mural-upload-preview img {\n  width: 100%;\n  max-height: 220px;\n  object-fit: cover;\n  border-radius: 10px;\n  border: 1px solid #d6e4f5;\n}\n\n.mural-attachment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mural-attachment-item {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: center;\n  border: 1px solid #d8e5f4;\n  border-radius: 8px;\n  padding: 8px 10px;\n}\n\n.mural-attachment-item span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #284e77;\n  font-size: 0.86rem;\n}\n\n.mural-spacer {\n  min-height: 1px;\n}\n\n@media (max-width: 620px) {\n  .mural-page {\n    padding: 0;\n  }\n\n  .mural-search {\n    min-width: 100%;\n  }\n\n  .mural-form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .mural-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .mural-manage-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .mural-notice-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .mural-notice-actions button {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .mural-attachment-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
